module.exports = __webpack_public_path__ + "static/media/Lato-regular.29e34814.svg";